import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import {NomeTipoPortal,NomePortal} from '../../../../../../../services/variables'
import {logoPortalBase64} from '../../../../../../../services/logoBase64'

export default  function PDFgenerateContrato(props) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    
    const data = props
    const arrayData2 = [
        [
            {text:  'EXERCICIO',bold: true,fontSize: 9},
             {text: 'NUMERO CONTRATO',bold: true,fontSize: 9},
             {text: 'DATA PUBLICACAO CONTRATO',bold: true,fontSize: 9},
             {text: 'DATA VIGENCIA INICIO',bold: true,fontSize: 9},
             {text: 'DATA VIGENCIA FIM',bold: true,fontSize: 9},
             {text: 'NOME FORNECEDOR',bold: true,fontSize: 9},
             {text: 'FORNECEDOR CNPJ',bold: true,fontSize: 9},
             {text: 'UNIDADE',bold: true,fontSize: 9},
             {text: 'STATUS CONTRATO',bold: true,fontSize: 9},
             {text: 'VALOR CONTRATO',bold: true,fontSize: 9},
             {text: 'OBJETO',bold: true,fontSize: 9},
            ]
    ]
  
    data.map((d, i) => {
        arrayData2.push([
            {text:  d.EXERCICIO,fontSize: 8},
             {text: d.NUMERO_CONTRATO,fontSize: 8},
             {text: d.DATA_PUBLICACAO_CONTRATO,fontSize: 8},
             {text: d.DATA_VIGENCIA_INICIO,fontSize: 8},
             {text: d.DATA_VIGENCIA_FIM,fontSize: 8},
             {text: d.NOME_FORNECEDOR,fontSize: 8},
             {text: d.FORNECEDOR_CPF_CNPJ,fontSize: 8},
             {text: d.NOME_UNIDADE,fontSize: 8},
             {text: d.STATUS_CONTRATO,fontSize: 8},
             {text: d.VALOR_CONTRATO,fontSize: 8},
             {text: d.OBJETO_CONTRATO,fontSize: 8},
            ]) 
    })
 
    const reportTitle = [
        {

        }
    ]
    const details = [
        {image: logoPortalBase64,
	    width: 50,height: 50,alignment: 'center'},	
        {text: `${NomeTipoPortal} de ${NomePortal}\n\n`,fontSize: 14,alignment: 'center'},
        {
			style: 'tableExample',
			table: {
				headerRows: 1,
				// dontBreakRows: true,
				// keepWithHeaderRows: 1,
				body: arrayData2
			}
		},
    ]
    // const footer = [{text: `Arquivo gerado no portal: ${new Date().toLocaleString()} \n`,fontSize: 8, alignment: 'center'}]
    const footer = [{text: ``}]

    
    const docDefinitions = {
        pageSize: 'A2',
        pageMargins:[15,50,15,40],
        headers : [reportTitle],
        content: [details],
        footer: [footer],
        
    }
 pdfMake.createPdf(docDefinitions).open()//.print()//.download()
    
}